import { render, staticRenderFns } from "./supervisionAnswerLists.vue?vue&type=template&id=62c59210"
import script from "./supervisionAnswerLists.vue?vue&type=script&lang=js"
export * from "./supervisionAnswerLists.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports